export default __webpack_public_path__ + "static/media/logo-manz.cd0a01e7.svg";